import React from "react";

function blueTick() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6628 3.30562C15.0463 3.67171 15.0604 4.27938 14.6943 4.6629L7.05798 12.6629C6.88079 12.8485 6.63668 12.9555 6.38011 12.9599C6.12354 12.9643 5.87588 12.8658 5.6924 12.6864L1.32876 8.41978C0.949673 8.04911 0.942843 7.44131 1.31351 7.06222C1.68418 6.68313 2.29198 6.6763 2.67107 7.04697L6.34 10.6344L13.3055 3.33718C13.6716 2.95367 14.2793 2.93953 14.6628 3.30562Z" fill="#01B5DE" />
        </svg>

    )
}
export default blueTick;